const BusinessAreaWareHouse = {

    // FIELDS
    "business_area": "مجال العمل",
    "name": "الاسم",
    "short_name": "الاسم المختصر",
    "address": "العنوان",
    "postal_code": "الرمز البريدي",
    "email": "البريد الإلكتروني",
    "status": "الحالة",
    "search": "البحث",

    // PAGE HEADER
    "ware_house": "المستودع",

    // ERROR
    "error_business_area": "يرجى اختيار مجال العمل",
    "error_name": "يرجى إدخال الاسم",
    "error_short_name": "يرجى إدخال الاسم المختصر",
    "error_address": "يرجى إدخال العنوان",
    "error_email": "يرجى إدخال البريد الإلكتروني",
    "error_postal_code": "يرجى إدخال الرمز البريدي",
    "error_status": "يرجى اختيار الحالة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_email": "البريد الإلكتروني",
    "table_area": "المجال",
    "table_status": "الحالة",
}

export default BusinessAreaWareHouse;